import { useCallback, useRef } from 'react';

import { useIsomorphicLayoutEffect } from './use-isomorphic-layout-effect';

/**
 * Stable Reference to a Callback Function
 * Use this if the callback function is used in a component that you
 * don't want to re-render when the callback changes.
 */
const useEvent = <T extends (...args: any[]) => any>(cb: T) => {
    const ref = useRef<T>(cb);
    useIsomorphicLayoutEffect(() => {
        ref.current = cb;
    }, [cb]);

    return useCallback((...args: Parameters<T>) => {
        return ref.current?.(...args);
    }, []);
};

export { useEvent };
